import styled from "styled-components";

export const StyledAssignMenu = styled.div`
    width: 100%;

    .title {
        color: var(--text-color);
        font-size: 18px;
        line-height: 22px;
        font-weight: 500;
        margin-bottom: 20px;
    }

    .menu-wrap {
        display: flex;
        gap: 20px;
        margin-bottom: 60px;

        @media (max-width: 768px) {
            flex-direction: column;
            margin-bottom: 30px;
        }

        .menu {
            width: 100%;
            border: 1px solid rgba(236, 236, 236, 1);
            border-radius: 15px;
            padding: 23px;
            text-align: center;
            cursor: pointer;
            transition: all 0.15s ease-in-out;
            &.active {
                border-color: var(--primary);
            }
            .icon {
                width: 40px;
                height: 40px;
                margin-bottom: 15px;
            }
            .title {
                display: block;
                color: var(--text-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
                margin-bottom: 8px;
            }
            .desc {
                color: rgba(143, 143, 143, 1);
                font-size: 12px;
                line-height: 16px;
                font-weight: 300;
            }
        }
    }

    .btn-wrap {
        display: flex;
        align-items: center;
        gap: 20px;

        @media (max-width: 768px) {
            flex-direction: column;
        }

        button {
            width: 100%;
        }
    }
`;
